import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import WithURLFilters from './components/WithURLFilters';
import style from './GameCategoriesControlPanel.module.scss';

const GameCategoriesControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.container}>
				<div className={style.firstRowWithControls}>
					<Search />
					<CreateBtn />
				</div>
				<div className={style.secondRowWithControls}>
					<ResetBtn />
					<div className={style.verticalAlignBlock}>
						<SortBy />
						<CountOfItem />
					</div>
				</div>
			</div>
		</WithURLFilters>
	);
};

export default GameCategoriesControlPanel;
